/* eslint-disable no-underscore-dangle */
// Copied from https://www.npmjs.com/package/chartjs-adapter-moment
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { _adapters } from 'chart.js';
import moment from 'moment';

const formats = {
    datetime: 'MMM D, YYYY, h:mm:ss a',
    millisecond: 'h:mm:ss.SSS a',
    second: 'h:mm:ss a',
    minute: 'h:mm a',
    hour: 'hA',
    day: 'MMM D',
    week: 'll',
    month: 'MMM YYYY',
    quarter: '[Q]Q - YYYY',
    year: 'YYYY',
};

_adapters._date.override(
    typeof moment === 'function'
        ? {
              //   _id: 'moment', // DEBUG ONLY

              formats() {
                  return formats;
              },

              parse(value: any, format) {
                  if (typeof value === 'string' && typeof format === 'string') {
                      value = moment(value, format);
                  } else if (!(value instanceof moment)) {
                      value = moment(value);
                  }
                  return value.isValid() ? value.valueOf() : null;
              },

              format(time, format) {
                  return moment(time).format(format);
              },

              add(time, amount, unit) {
                  return moment(time).add(amount, unit).valueOf();
              },

              diff(max, min, unit) {
                  return moment(max).diff(moment(min), unit);
              },

              startOf(time: any, unit, weekday: any) {
                  time = moment(time);
                  if (unit === 'isoWeek') {
                      weekday = Math.trunc(Math.min(Math.max(0, weekday), 6));
                      return time.isoWeekday(weekday).startOf('day').valueOf();
                  }
                  return time.startOf(unit).valueOf();
              },

              endOf(time, unit) {
                  return moment(time).endOf(unit).valueOf();
              },
          }
        : {},
);
